module.exports = __webpack_public_path__ + "static/safari-9785b81d5152f9c8401ed0db158b9bee.svg";